import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { LoaderService } from 'src/app/Services/loader.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { driverModule } from '../../../../../../modules/information/driver';
import { EscortComponent } from '../escort.component';
declare const Swal;

@Component({
  selector: 'app-viewescort',
  templateUrl: './viewescort.component.html',
  styleUrls: ['./viewescort.component.css']
})
export class ViewEscortComponent implements OnInit {

  public toggleUploadVeh: boolean = false;
  public uploadedExcel: any;

  public xlFileName: any = '';
  public enableFileName: boolean = false;

  public closeExlUploadAlert: boolean = true;
  public exlUploadPopup: boolean = true;
  public exlUploadRes: any;
  public exlUploadTable = [
    { key: 'name', display: 'Escort Name', width: '130px' },
    { key: 'empRefID', display: 'Escort ID', config: { isUppercase: true, }, width: '110px' },
    { key: 'email', display: 'Email', width: '130px' },
    {
      key: 'dob', display: 'DOB',
      config: {
        isDate: true,
        format: 'dd MMM YYYY'
      },
      width: '110px'
    },
    {
      key: 'bloodGroup', display: 'Blood-Group',
      config: {
        isUppercase: true
      },
      width: '130px'
    },
    { key: 'gender', display: 'Gender', width: '110px' },
    { key: 'mobile', display: 'Mobile', width: '110px' },
    { key: 'emergencyContact', display: 'Emergency Contact', width: '110px' },
    { key: 'workLocation', display: 'Work Location', width: '110px' },
    {
      key: 'branch', display: 'Branch',
      config: {
        isBranch: true,
      },
      width: '110px'
    },
    {
      key: 'shift', display: 'Shift',
      config: {
        isShift: true,
      },
      width: '110px'
    },
    { key: 'transportType', display: 'Transport Type', width: '110px' },
    { key: 'department', display: 'Department', width: '110px' },
    { key: 'address', display: 'Address', width: '110px' },
    { key: 'city', display: 'City', width: '110px' },
    { key: 'state', display: 'State', width: '110px' },
    { key: 'country', display: 'Country', width: '110px' },
    { key: 'pincode', display: 'Pincode', width: '80px' },
    { key: 'location', display: 'location', width: '110px' },
  ]

  constructor(
    public api: ApiService,
    public router: Router,
    public storage: StorageService,
    public location: Location,
    public swal: SweetAlert,
    public route: ActivatedRoute,
    public loader: LoaderService,
  ) {
    this.route.paramMap.subscribe(params => {
      this.orgID = params.get('orgID');
    });
    this.userData = this.storage.get('vendorViewData');
  }

  public driverInfo: any = driverModule;
  userData: any;
  public employeeInformation: any;
  orgID: string;
  vendorID: string;
  public values: any = [];
  public editForm: boolean;
  public filterTable: boolean = true;
  public tableShow: boolean = false;
  public cols = [
    { key: '#', display: '#' },
    { key: 'name', display: 'Name' },
    // { key: 'bloodGroup', display: 'Blood Group',config: { isUppercase: true }},
    { key: 'mobile', display: 'Mobile' },
    { key: 'department', display: 'Department' },
    { key: 'empRefID', display: 'Employee ID', config: { isUppercase: true, },
    headerConfig:{ isDefault: true}},
    // { key: 'dob', display: 'Date Of Birth', config: {isDate: true, format: 'dd MMM YYYY'}},
    // { key: 'city', display: 'City' },
    // { key: 'state', display: 'State' },
    // { key: "city", display: "City" },
    {
      key: 'action',
      display: 'Action',
      config: {
        isAction: true,
        actions: [
          { display: 'View', color: 'primary', icon: 'View' },
          { display: 'Update', color: 'primary', icon: 'Edit', class:'fs-13' },
          { display: 'Delete', color: 'warn', icon: 'Delete' }
        ]
      }
    }
  ];
  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  }


  /* filters */
  searchChangeObserver: any;
  public searchInputValue = '';

  ngOnInit() {
    this.getEmployeeList();
  }

  getEmployeeList(page = 1, limit = 10, search?, department = "escort") {
    const obj = {
      orgID: this.storage.get('userInfo').orgID,
      page: page,
      limit: limit,
      department: "escort",
    };
    if (search) obj['search'] = search;

    this.api.transportManagerEscortList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.processTableData(res.data);
        this.processPagination(res, obj);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  processPagination(data, req) {
    this.tableShow = false;
    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.totCnt, req.limit,),
    }
    this.tableShow = true;
  }

  getTotalCount(total, limit) {
    let result: any = 1;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data) {
    this.getEmployeeList(data.page, data.limit, this.searchInputValue);
  }

  onSearchChange(searchValue: string) {

    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.searchChangeObserver) {
      new Observable(observer => {
        this.searchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          this.searchInputValue = term;
          if (String(term).length == 0) this.getEmployeeList(1, this.paginationData.limit, term);
          else if (String(term).length >= 2) this.getEmployeeList(1, this.paginationData.limit, term);

        });
    }

    this.searchChangeObserver.next(searchValue);
  }

  processTableData(data) {
    this.tableShow = false;
    this.employeeInformation = data.map((emp) => {
      let obj = {
        name: emp.name,
        bloodGroup: emp.bloodGroup,
        empRefID: emp.empRefID,
        dob: emp.dob,
        city: emp.city,
        state: emp.state,
        orgID:emp.orgID,
        escortID: emp.escortID,
        department:emp.department,
        mobile:emp.mobile
      }
      return obj;
    });
    setTimeout(() => { this.tableShow = true; }, 100);
  }

  downloadTemplate() {
    document.getElementById('excelTemplate').click();
  }

  uploadExcelFile() {
    document.getElementById('employeeExcelUpload').click();
  }

  //   uploadEmployee(event) {
  //     this.loader.show();
  //     this.xlFileName = event.target.files[0].name;
  //     this.enableFileName = true;
  //     let apiObj = {

  //     }
  //     let url = 'organization/excel/addEmployee';
  // console.log(this.exlUploadTable)
  //     this.api.xlsxFileUpload(apiObj, url, 'employeeExcelUpload', (res: any) => {
  //       this.loader.hide();
  //       console.log(res.responseJSON);

  //       if ((res.responseJSON.exitsData && res.responseJSON.exitsData != {}) || (res.responseJSON.validationFails && res.responseJSON.validationFails != {})) {
  //         this.exlUploadRes = res.responseJSON;

  //         this.closeExlUploadAlert = false;
  //       }
  //       else if (res.responseJSON.status == 'success' && res.responseJSON.message) {
  //         this.swal.swalFunction(res.responseJSON.status, res.responseJSON.status, res.responseJSON.message, 5000);
  //         setTimeout(() => { this.getEmployeeList(); }, 5000);

  //       }
  //       else if (res.responseJSON.status == 'failure' ) {
  //         // this.swal.swalFunction(res.responseJSON.status, res.responseJSON.status, res.responseJSON.message, 10000);
  //         this.swal.swalFunction('error',res.responseJSON.status,res.responseJSON.message, 2000);
  //       }
  //       let doc: any = document.querySelector('#employeeExcelUpload');
  //       doc.value = '';
  //     });
  //   }

  onActionHandler(e: any) {
    const data = e.data;
    if (e.action.display.toLowerCase() == 'update') {
      this.router.navigate(['/organization/transport-manager/information/orgInfo/escort/edit-escort', e.data.escortID]);

    } else if (e.action.display.toLowerCase() == 'delete') {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to delete this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',//'#3085d6',
        //  cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteEmployeeData(e);
        }
      });
    } else if (e.action.display.toLowerCase() == 'view') {
      this.router.navigate(['/organization/transport-manager/information/orgInfo/escort/single-view-escort', e.data.escortID]);
    }
  }

  deleteEmployeeData(e?) {

    const obj = {
      orgID: e.data.orgID,
      escortID: e.data.escortID,
      department:e.data.department
    };

    this.api.transportManagerEscortDelete(obj).then((res: any) => {
      if (res.status == 'success') {
        if (res.data == undefined || res.data == '') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.tableShow = true;
          this.getEmployeeList(1, this.paginationData.limit, this.searchInputValue);
        } else {
          this.empRouteRemovePopup(res.data);
        }
      } else {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  empRouteRemovePopup(routes) {
    let fireContent = {
      title: 'Remove Employee from Assigned Route!',
      icon: 'warning',
    };
    if (routes.length > 0) {
      let htmlContent = '';
      for (let r = 0; r < routes.length; r++) {
        if (routes[r].title) htmlContent += `<tr><td class="border-top-0">${r + 1} .</td><td class="border-top-0 text-left">${routes[r].title}</td></tr>`;
      }
      if (routes.length > 1) fireContent['title'] = 'Remove Employee from Assigned Routes!';
      fireContent['html'] = `<div class="row px-5"><div class="col-12 px-5" style="max-height:200px;overflow-y:auto;"><table class="table table-responsive table-sm">` + htmlContent + `</table></div></div>`;
      setTimeout(() => {
        Swal.fire(fireContent);
      }, 300);
    }
  }
  // getPage(v, v2) { }
}
